import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { EmployeeService } from '../../../../_services/employee-service/employee.service';
import { NgSelectModule } from '@ng-select/ng-select';
import { BoFormsModule } from '@bo/ng-forms';
import { AsyncPipe, NgClass } from '@angular/common';

@Component({
  selector: 'app-employees-select-multi',
  imports: [NgSelectModule, BoFormsModule, NgClass, AsyncPipe],
  templateUrl: './employee-select-multi.component.html',
})
export class EmployeeSelectMultiComponent {
  protected employeeService = inject(EmployeeService);

  @Input() filterLabel: boolean = false;
  @Input() selectedEmployees: string[] = [];
  @Output() selectionChanged: EventEmitter<string[]> = new EventEmitter<string[]>();
  employeeOptions$ = this.employeeService.employeeAllOptions();

  changeSelection(): void {
    this.selectionChanged.emit(this.selectedEmployees);
  }
}
